var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrjay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "2592pt",
    height: "1728pt",
    viewBox: "0 0 2592 1728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,1728)",
    d: "M0 1728H2592V0H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,1728)",
    d: "M0 1728H2592V0H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,746.7656,503.7505)",
    d: "M0 0V-286.371C0-410.283-100.449-510.725-224.361-510.725-353.394-510.725-458-406.125-458-277.086V0H-342.314L-340.12-349.989-243.009-294.77C-235.993-428.352-170.705-510.446-171.769-496.107-187.198-288.545-115.639-119.37-115.639-119.37L-215.769-172.507-195.312 0Z",
    fill: "#9cc53d"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#231f20",
    xmlSpace: "preserve",
    transform: "matrix(.98702648 0 -0 1.013144 0 1728)",
    fontSize: 73.05812,
    fontFamily: "Poppins",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -1136.2903,
    x: "2249.3944 2291.5489"
  }, "TM")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,976.5874,966.8008)",
    d: "M0 0C-40.416 0-70.655 11.146-90.71 33.436-110.772 55.727-120.794 90.397-120.794 137.462V315.791H-69.669V136.996C-69.669 106.347-64.169 84.209-53.155 70.587-42.148 56.962-24.278 50.154 .454 50.154 25.789 50.154 43.73 56.962 54.296 70.587 64.849 84.209 70.129 106.347 70.129 136.996V315.791H121.254V137.462C121.254 90.397 111.447 55.727 91.845 33.436 72.237 11.146 41.628 0 0 0",
    fill: "#576cb3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1352.0879,872.5283)",
    d: "M0 0C-4.527 8.359-9.502 15.247-14.931 20.666-20.36 26.079-26.541 30.417-33.481 33.669-35.988 34.841-38.703 35.81-41.521 36.68-29.904 38.198-19.021 40.962-9.048 45.28 6.331 51.932 18.551 61.918 27.6 75.231 36.647 88.54 41.169 105.105 41.169 124.922 41.169 146.284 36.492 164.084 27.146 178.329 17.792 192.566 4.976 203.326-11.312 210.606-27.599 217.876-46 221.518-66.503 221.518H-184.592V175.08H-71.484C-60.626 175.08-50.67 173.525-41.622 170.436-32.573 167.336-25.413 162.073-20.133 154.643-14.859 147.213-12.213 136.836-12.213 123.531-12.213 111.144-14.859 101.31-20.133 94.04-25.413 86.762-32.573 81.576-41.622 78.483-50.67 75.384-60.626 73.839-71.484 73.839H-184.592V30.649H-114.917C-100.439 30.649-89.056 28.632-80.76 24.614-72.464 20.586-65.452 13.309-59.719 2.786L-7.692-89.629H51.579Z",
    fill: "#576cb3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1579.3467,966.8008)",
    d: "M0 0C-31.666 0-57.683 9.128-78.043 27.4-98.403 45.663-112.05 70.587-118.983 102.168L-74.65 135.604C-71.641 110.831-64.246 90.397-52.48 74.302-40.714 58.203-23.228 50.154 0 50.154 14.775 50.154 26.393 52.711 34.838 57.817 43.276 62.927 49.387 71.516 53.161 83.59 56.93 95.667 58.817 111.919 58.817 132.352V315.791H109.942V124.922C109.942 94.889 105.869 70.74 97.722 52.478 89.582 34.205 77.439 20.899 61.302 12.54 45.164 4.178 24.726 0 0 0",
    fill: "#576cb3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1793.2031,962.1572)",
    d: "M0 0H-53.836L64.7 311.147H123.512L242.048 0H185.494L109.488 208.049 93.201 264.242 76.914 208.049Z",
    fill: "#576cb3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,1728)",
    d: "M2189.011 765.843H2137.887V900.05307H2189.011ZM2183.128 867.546H2143.77L2023.878 1076.99H2087.216L2132.004 991.539 2163.676 920.023 2196.704 991.076 2243.755 1076.99H2303.021Z",
    fill: "#576cb3"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#231f20",
    xmlSpace: "preserve",
    transform: "matrix(.98702558 0 -0 1.013145 0 1728)",
    fontSize: 123.670459,
    fontFamily: "Red Hat Display",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -554.5609,
    x: "314.98567 398.71058 467.3477 530.9143 604.86929 640.1153 719.2644 754.2632 829.20748 901.5547 954.1147 1014.2185 1049.2173 1122.0592 1157.058 1208.7522 1273.9265 1322.158 1418.7446 1489.9789 1524.9776 1599.3035 1634.5496 1715.5415 1774.0375 1846.8917 1918.7444 1972.1577 2043.3919 2119.0782 2154.077 2189.0758 2224.0743 2275.7689"
  }, "Save Electricity-Gain Pro&#xfb01;tability")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrjay);
export default __webpack_public_path__ + "static/media/urjay.a4b7ce6d9417ef450744aac9d1299fee.svg";
export { ForwardRef as ReactComponent };